import angular from 'angular';
import _ from 'lodash';

function AddAdmissionGroupReceiptsCtrl($scope, $panelInstance, venue, date, admissionGroup, colorService, admissionGroupService, alertService, sdkUtils) {
  _initScope();

  function _initScope() {
    $scope.admissionGroup = admissionGroup;
    $scope.loading = false;
    $scope.venue = venue;
    $scope.venueBrandColors = $scope.venue.branding ? {
      primaryColor: $scope.venue.branding.primaryColor ? colorService.rgbToHex($scope.venue.branding.primaryColor.red, $scope.venue.branding.primaryColor.green, $scope.venue.branding.primaryColor.blue) : null //eslint-disable-line
    } : {};
    $scope.date = date;
    $scope.admissionGroupReceiptsForm = {
      receipts: angular.copy($scope.admissionGroup.receipts || [])
    };

    if (!$scope.admissionGroupReceiptsForm.receipts || !$scope.admissionGroupReceiptsForm.receipts.length) {
      $scope.admissionGroupReceiptsForm.receipts.push({
        name: 'Receipt 1',
        subtotal: '0'
      });
    }

    $scope.saveAdmissionGroup = function (angularForm, $event) {
      if ($event) $event.preventDefault();

      $scope.submitted = true;

      if (!angularForm.$valid) return null;

      $scope.saving = true;

      const receipts = _.filter($scope.admissionGroupReceiptsForm.receipts, receipt => {
        return receipt.type !== 'INTERNAL' && receipt.type !== 'INTERNAL_AUTH';
      });

      return admissionGroupService.updateById($scope.admissionGroup.id, {
          receipts
        })
        .then(result => {
          $panelInstance.close({
            admissionGroup: result
          });

          $scope.saving = false;
        })
        .catch(error => {
          $scope.saving = false;

          alertService.error(sdkUtils.getErrorFromResponse(error));
        });
    };

    $scope.closePanel = function ($event) {
      if ($event) $event.preventDefault();

      $panelInstance.close(false);
    };
  }
}

AddAdmissionGroupReceiptsCtrl.$inject = [
  '$scope',
  '$panelInstance',
  'venue',
  'date',
  'admissionGroup',
  'colorService',
  'jsSdk.admissionGroup',
  'alertService',
  'jsSdk.utils'
];

export default AddAdmissionGroupReceiptsCtrl;



// WEBPACK FOOTER //
// ./src/panels/addAdmissionGroupReceipts/controller.js